var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from "formik";
import { useState } from "react";
import useAuth from "../../hooks/useAuth";
import useTitle from "../../hooks/useTitle";
import { Button, InputDate, InputSelect, InputText } from 'template/lib';
import styles from './styles.module.scss';
var Filter = function (props) {
    var _a;
    var title = useTitle().title;
    var login = useAuth().login;
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var _b = useState(null), companyId = _b[0], setCompanyId = _b[1];
    var _c = useState(null), softwareId = _c[0], setSoftwareId = _c[1];
    var parseSelectValue = function (e, filter) {
        var rawValue = (e === null || e === void 0 ? void 0 : e.target) ? e.target.value : e;
        // Se n�o houver op��es, retorna como string
        if (!filter.options || filter.options.length === 0) {
            return rawValue;
        }
        var sampleId = filter.options[0].id;
        // ID num�rico ? converte
        if (!isNaN(Number(sampleId))) {
            return Number(rawValue);
        }
        // ID string ? mant�m
        return rawValue;
    };
    var formik = useFormik({
        initialValues: {},
        enableReinitialize: true,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, props.stateOfFilter(__assign({}, values))];
                    case 1:
                        _a.sent();
                        props.page();
                        return [2 /*return*/];
                }
            });
        }); }
    });
    /** Handler compat�vel com event OU value */
    var getSelectValue = function (e) {
        if (e === null || e === void 0 ? void 0 : e.target)
            return Number(e.target.value);
        return Number(e);
    };
    var renderFilter = function (filter) {
        var _a, _b, _c, _d, _e;
        switch (filter.dataType) {
            case 'Text':
                return (_jsx("div", { children: _jsx(InputText, { name: filter.fieldName, label: filter.fieldDisplay, value: (_a = formik.values[filter.fieldName]) !== null && _a !== void 0 ? _a : '', onChange: formik.handleChange }, void 0) }, filter.fieldName));
            case 'Date':
                return (_jsx("div", { children: _jsx(InputDate, { name: filter.fieldName, label: filter.fieldDisplay, value: (_b = formik.values[filter.fieldName]) !== null && _b !== void 0 ? _b : '', onChange: formik.handleChange }, void 0) }, filter.fieldName));
            case 'Select': {
                var items = {
                    label: filter.fieldDisplay,
                    options: (_c = filter.options) !== null && _c !== void 0 ? _c : []
                };
                var isStringIdSelect = filter.fieldName === 'AssignedToId' ||
                    filter.fieldName === 'ClosedById';
                // ?? SELECT STRING (CSS PRESERVADO)
                if (isStringIdSelect) {
                    return (_jsxs("div", __assign({ className: "selectContainer" }, { children: [_jsx("label", __assign({ className: "selectLabel" }, { children: filter.fieldDisplay }), void 0), _jsxs("select", __assign({ className: "selectInput selectInputWidthDefault", name: filter.fieldName, value: (_d = formik.values[filter.fieldName]) !== null && _d !== void 0 ? _d : '', onChange: function (e) {
                                    var value = e.target.value;
                                    formik.setFieldValue(filter.fieldName, value);
                                } }, { children: [_jsx("option", __assign({ value: "" }, { children: "Selecione..." }), void 0), items.options.map(function (opt) { return (_jsx("option", __assign({ value: opt.id, className: "text-gray-600" }, { children: opt.display }), opt.id)); })] }), void 0)] }), filter.fieldName));
                }
                // ?? INPUTSELECT NUM�RICO (INALTERADO)
                return (_jsx("div", { children: _jsx(InputSelect, { values: items, name: filter.fieldName, value: (_e = formik.values[filter.fieldName]) !== null && _e !== void 0 ? _e : '', valueMember: "id", displayMember: "display", onChange: function (e) {
                            var _a, _b;
                            var rawValue = (_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : e;
                            var id = Number(rawValue);
                            //if (Number.isNaN(id)) return
                            formik.setFieldValue(filter.fieldName, id);
                            if (filter.fieldName === 'CompanyId')
                                setCompanyId(id);
                            if (filter.fieldName === 'SoftwareId')
                                setSoftwareId(id);
                        } }, void 0) }, filter.fieldName));
            }
            default:
                return null;
        }
    };
    return (_jsx("form", __assign({ onSubmit: formik.handleSubmit }, { children: _jsx("div", __assign({ className: styles.grid }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 my-2 justify-items-end" }, { children: [props.data.map(renderFilter), ((login === null || login === void 0 ? void 0 : login.role) === 'Customer' || (login === null || login === void 0 ? void 0 : login.role) === 'CustomerAdmin') && (_jsxs("div", __assign({ className: styles.checkBox }, { children: [_jsx("div", {}, void 0), _jsx("label", { children: "Mostrar fechados" }, void 0), _jsx("input", { type: "checkbox", checked: (_a = formik.values.showClosed) !== null && _a !== void 0 ? _a : false, onChange: function (e) {
                                    return formik.setFieldValue('showClosed', e.target.checked);
                                } }, void 0)] }), "showClosed")), _jsxs("div", __assign({ className: styles.button }, { children: [props.closer && (_jsx(Button, __assign({ type: "button", onClick: props.closer }, { children: "Cancelar" }), void 0)), _jsx(Button, __assign({ type: "submit" }, { children: "Pesquisar" }), void 0)] }), void 0)] }), void 0) }), void 0) }), void 0));
};
export default Filter;
